export default __webpack_public_path__ + "static/media/30_mountains.aae2e488.JPG";